export default __webpack_public_path__ + "static/media/icon-truseat.10049fb8.svg";